import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import TextButton from "@shared/v2/TextButton";
import { CalendarCheckSolidV6 } from "@shared/v2/Icomoon";

const CardDetail = ({ title, value }) => (
  <div className="tw-flex tw-items-baseline tw-gap-[4px]">
    <span className="tw-text-11d tw-font-bold tw-uppercase">{title}:</span>
    <span className="tw-text-14d tw-max-h-[200px] tw-whitespace-pre-wrap tw-break-words tw-overflow-y-auto tw-overflow-x-hidden">
      {value}
    </span>
  </div>
);

CardDetail.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const CardAppointment = ({ task, showTaskDetails }) => (
  <div className="tw-shadow-card tw-rounded-[6px] tw-p-[16px] tw-flex tw-flex-col tw-gap-[16px]">
    <div className="tw-flex tw-gap-[4px]">
      <CalendarCheckSolidV6 size="l" />
      <TextButton
        schema="sentence"
        size="medium"
        className="!tw-text-gray-75"
        onClick={() => showTaskDetails(task)}
      >
        {task.name}
      </TextButton>
      {moment(task.due_on).format("MM/DD/YY")}
    </div>

    {task.appointment_type && <CardDetail title="Type" value={task.appointment_type} />}
    {task.outcome && <CardDetail title="Outcome" value={task.outcome} />}
    {task.location && <CardDetail title="Location" value={task.location} />}
    {task.note && <CardDetail title="Notes" value={task.note} />}
    <CardDetail title="Status" value={task.completed_at ? "Completed" : "Scheduled"} />
  </div>
);

CardAppointment.propTypes = {
  task: PropTypes.shape().isRequired,
  showTaskDetails: PropTypes.func.isRequired,
};

export default CardAppointment;
